import { render, staticRenderFns } from "./list4.vue?vue&type=template&id=66981234&scoped=true&"
import script from "./list4.vue?vue&type=script&lang=js&"
export * from "./list4.vue?vue&type=script&lang=js&"
import style0 from "./list4.vue?vue&type=style&index=0&id=66981234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66981234",
  null
  
)

export default component.exports